import {
  ADD_LEAVE,
  ADD_LEAVE_FAILED,
  ADD_LEAVE_SUCCESS,
  ADD_MONTHLY_LEAVE,
  ADD_MONTHLY_LEAVE_FAILED,
  ADD_MONTHLY_LEAVE_SUCCESS,
  LEAVE,
  LEAVE_FAILED,
  LEAVE_SUCCESS,
  UPDATE_LEAVE,
  UPDATE_LEAVE_FAILED,
  UPDATE_LEAVE_SUCCESS,
} from "./actionTypes";

let initialState = {
  leave: [],
  addLeave: "",
  addMonthlyLeave: "",
  updateLeave: "",
  loading: false,
  success: false,
  error: "",
};

export const leaveReducer = (state = initialState, action) => {
  switch (action.type) {
    case LEAVE:
      return {
        ...state,
        loading: true,
        success: false,
        error: "",
      };
    case LEAVE_SUCCESS:
      return {
        ...state,
        leave: action.payload,
        loading: false,
        success: true,
      };
    case LEAVE_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload,
      };
    case ADD_LEAVE:
      return {
        ...state,
        loading: true,
        success: false,
        error: "",
      };
    case ADD_LEAVE_SUCCESS:
      return {
        ...state,
        addLeave: action.payload,
        leave: [...state.leave, ...action.payload],
        loading: false,
        success: true,
        error: "",
      };
    case ADD_LEAVE_FAILED:
      return {
        ...state,
        addLeave: [],
        loading: false,
        success: false,
        error: action.payload,
      };
    case ADD_MONTHLY_LEAVE:
      return {
        ...state,
        loading: true,
        success: false,
        error: "",
      };
    case ADD_MONTHLY_LEAVE_SUCCESS:
      return {
        ...state,
        addMonthlyLeave: action.payload,
        leave: [...state.leave, ...action.payload],
        loading: false,
        success: true,
        error: "",
      };
    case ADD_MONTHLY_LEAVE_FAILED:
      return {
        ...state,
        addMonthlyLeave: [],
        loading: false,
        success: false,
        error: action.payload,
      };
    case UPDATE_LEAVE:
      return {
        ...state,
        loading: true,
        success: false,
        error: "",
      };
    case UPDATE_LEAVE_SUCCESS:
      return {
        ...state,
        updateLeave: action.payload,
        leave: state.leave.map((item) =>
          item.id === action.payload.id ? action.payload : item
        ),
        loading: false,
        success: true,
        error: "",
      };
    case UPDATE_LEAVE_FAILED:
      return {
        ...state,
        updateLeave: [],
        loading: false,
        success: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
